<template>
  <div>
    <!-- Menu de Navegação versão Desktop -->
    <div class="d-none d-md-block">
      <div class="nav-brand"><img src="../images/sigecor-branco.png" /></div>
      <b-navbar toggleable="lg" type="dark" variant="dark">
        <b-navbar-brand href="#">
          
          <!-- <img width="16px" v-else src="../images/user.png" /> -->
          <span v-if="this.user.nome" class="ml-2">{{ this.user.nome }}</span>
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item class="menu-text">
              <router-link
                class="link-text-menu"
                :to="{
                  path: '/',
                  query: { api_key: this.$store.getters.getApiKey },
                }"
              >
                Ùltimas Vagas
              </router-link>
            </b-nav-item>

            <b-nav-item class="menu-text" v-b-modal.modal-1>
              <router-link class="link-text-menu" :to="'/'">
                Àreas/Cargos
              </router-link>
            </b-nav-item>
            <b-nav-item>
              <router-link
                class="link-text-menu"
                :to="{
                  name: 'curriculo_main',
                  query: { api_key: this.$store.getters.getApiKey },
                }"
              >
                Meu Currículo
              </router-link>
            </b-nav-item>
            <b-nav-item
              v-if="
                this.user.nome && this.token !== null && this.token.length > 0
              "
              href="#"
            >
              <router-link
                class="link-text-menu"
                :to="{ name: 'vagas_encaminhadas' }"
              >
                Vagas Encaminhadas
              </router-link>
            </b-nav-item>
            <b-nav-item
              v-if="
                this.user.nome && this.token !== null && this.token.length > 0
              "
              href="#"
              @click="sairConta"
            >
              <span class="link-text-menu ml-1">Sair</span>
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>

    <!-- Menu de Navegação versão Mobile -->
    <div class="d-md-none">
      <div>
        <b-navbar type="dark" variant="dark">
          <b-navbar-brand tag="h1" class="mb-0"
            ><img src="../images/sigecor-branco.png"
          /></b-navbar-brand>
          <Slide>
            <img
              class="avatar-user-mobile"
              v-if="this.user.foto.nome"
              :src="this.user.foto.nome"
            />
            <span v-if="this.user.nome">
              Bem vindo <br />
              {{ this.user.nome }}
            </span>
            <div style="text-center">
              <router-link class="menu-text" :to="'/'">
                <h4 class="text-menu-mobile">Ùltimas Vagas</h4>
              </router-link>
            </div>

            <div>
              <div v-b-modal.modal-1>
                <h4 class="text-menu-mobile">Àreas/Cargos</h4>
              </div>
            </div>

            <div style="text-center">
              <router-link
                class="text-menu-mobile"
                :to="{
                  name: 'curriculo_main',
                  query: { api_key: this.$store.getters.getApiKey },
                }"
              >
                <h4>Currículo</h4>
              </router-link>
            </div>

            <div>
              <router-link
                class="text-menu-mobile"
                :to="{ name: 'vagas_encaminhadas' }"
              >
                <h4>Encaminhadas</h4>
              </router-link>
            </div>
            <div>
              <span
                class="text-menu-mobile ml-0"
                v-if="
                  this.user.nome && this.token !== null && this.token.length > 0
                "
                href="#"
                @click="sairConta"
              >
                <h4>Sair da conta</h4>
              </span>
            </div>
          </Slide>
        </b-navbar>
      </div>
    </div>
    <!-- Final do menu mobile -->

    <div>
      <b-modal
        id="modal-1"
        title="Vagas por Àrea"
        scrollable
        class="test-modal"
      >
        <p class="modal-text">
          Toque no nome da vaga para selecionar.<br />
          <span class="text-danger">
            Role a tela para visualizar mais categorias.
          </span>
          <br /><br />
          <a href="#" v-for="area in this.areas" v-bind:key="area.id">
            <router-link :to="{ name: 'vagas_area', params: { nome: area } }">
              <hr />
              <span class="vagas-area-titulo"> {{ area.titulo }} </span> <br />
              <span class="numero-vagas-disp">
                Número de Vagas Disponíveis:
                <b-badge variant="danger">{{ area.numeroVagas }}</b-badge>
              </span>
            </router-link>
          </a>
        </p>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { Slide } from "vue-burger-menu";

export default {
  data() {
    return {
      isOpen: true,
    };
  },
  methods: {
    openMenu() {
      this.isOpen = true;
    },
    detalhesVaga(item) {
      this.$router.push({
        name: "vagas_detalhe",
        params: { nome: item },
      });
    },
    sairConta() {
      let self = this;
      this.$store.dispatch("setSair");
      this.$router.push({
        name: "curriculo_main",
      });

      if (this.$gAuth.isAuthorized == true) {
        self.logOutGoogle();
      }
    },
    async logOutGoogle() {
      this.$gAuth.signOut();
      this.$store.dispatch("actGoogleObj", {});
    },

    cadastro() {
      let self = this;

      self.$router.push({
        name: "curriculo_main",
        params: { api_key: this.$store.getters.getApiKey },
        query: {
          api_key: this.$store.getters.getApiKey,
        },
      });
    },
  },
  beforeMount() {
    this.$store.dispatch("vagasAreasLoad", this.$store.getters.getApiKey);
  },
  computed: {
    user: function () {
      return this.$store.getters.getUser;
    },
    areas: function () {
      return this.$store.getters.getAreas;
    },
    token: function () {
      return this.$store.getters.getToken;
    },
  },
  components: {
    Slide,
  },
};
</script>

<style>
/*Cor do menu*/
.bg-dark {
  background-color: var(--main-menu-color) !important;
}
.link-text-menu {
  font-weight: bold;
  text-decoration: none;
  color: var(--main-menu-link) !important;
}
.link-text-menu:hover {
  text-decoration: none;
}
.avatar-user {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-top: -10px;
}
.nav-brand {
  float: left;
  background: var(--main-menu-color-brand);
  padding: 12px;
  min-height: 56px;
}

/* Configuração do menu mobile */
.bm-burger-bars {
  background-color: var(--mobile-menu-burguer) !important;
}
.bm-menu {
  background-color: var(--mobile-menu-color) !important;
}
.text-menu-mobile {
  color: var(--mobile-menu-link) !important;
}
.avatar-user-mobile {
  width: 128px;
  height: 128px;
  border-radius: 50%;
}
</style>
